import { combineReducers } from 'redux';
import { dateAvailability } from './dateAvailability';
import { timeAvailability } from './timeAvailability';
export var createTimeslotReducers = function () {
    return combineReducers({
        timeAvailability: timeAvailability,
        dateAvailability: dateAvailability,
    });
};
